import { Navigate, Route, Routes } from "react-router"
import { ReportPage } from "./[id]"

export const ReportsLayout = () => {
    return (
        <Routes>
            <Route path=":id" element={<ReportPage/>}/>
            <Route path="*" element={<Navigate to=".."/>}/>
        </Routes>
    )
}